import { motion, AnimatePresence } from 'framer-motion';
import { FC } from 'react';


export const StatePageContainer: FC<{children:React.ReactNode; id: string}> = ({children, id}) => {
    return (
        <motion.div
        key={id}
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: 20 }}
        transition={{ duration: 0.3 }}
      >{children}</motion.div>
    )
} 